// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// REPOSITORY SCHEMA
/////////////////////////////////////////

export const RepositorySchema = z.object({
  id: z.number().int(),
  name: z.string(),
  owner: z.string(),
  targetBranch: z.string().nullable(),
  targetPath: z.string().nullable(),
})

export type Repository = z.infer<typeof RepositorySchema>

export default RepositorySchema;
